/*=====================================
    開立發票列表

    Author: Gray
    createtime: 2018 / 01 / 10
=====================================*/

/*--------------------------
    Import
--------------------------*/
import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { parse } from 'qs';
import filter from 'lodash/filter';
import download from 'downloadjs';
import actionCreators from 'actions/creators';
import classNames from "classnames";
import DayPickerInput from 'react-day-picker/DayPickerInput';
import {formatDate, parseDate} from 'react-day-picker/moment';
import 'react-day-picker/lib/style.css';
import CupoyRouter from "components/commons/router/CupoyRouter";
import PagedList from 'components/commons/PagedList';
import InvoiceListHeader from './InvoiceListHeader';
import InvoiceListItem from './InvoiceListItem';
import Dropdown from 'components/commons/Dropdown';
import debounce from 'lodash/debounce';

/*--------------------------
    Variables
--------------------------*/
const SearchIcon = require('react-icons/lib/md/search');
const AngleDownIcon = require('react-icons/lib/fa/angle-down');
const SearchTypeMap = {
    ORDERID: 'orderid',
    INVOICENUMBER: 'invoicenumber',
};

/*--------------------------
    Main Component
--------------------------*/
class InvoiceListView extends Component {

    // ------------------------------
    // constructor
    // ------------------------------
    constructor(props) {

        super(props);

        this.state = {
            page: 1,
            keyword: '',
            currentKeyword: '',
            startDay: '',
            endDay: '',
            isFilterTime: false,
            yearmonth: undefined,
            isFilterYearmonth: false,
            searchType: SearchTypeMap.ORDERID,
            failstatus: '-1',
            isFilterFailtstatus: false,
            senddonatestatus: '-1',
            isFilterSenddonatestatus: false,
            typeTurnkeyupcasttime: '0',
            isFilterTypeTurnkeyupcasttime: false,
        };

        this.toggleIsFilterTime = this.toggleIsFilterTime.bind(this);
        this.onDaySelectChange = this.onDaySelectChange.bind(this);
        this.onFilterChange = this.onFilterChange.bind(this);
        this.renderCustomDayPickerOverlay = this.renderCustomDayPickerOverlay.bind(this);
        this.onInputChange = this.onInputChange.bind(this);
        this.enterSubmit = this.enterSubmit.bind(this);
        this.searchSubmit = this.searchSubmit.bind(this);
        this.deb_searchSubmit = debounce(this.searchSubmit, 1000);
        this.openDownloadTaxMediaDialog = this.openDownloadTaxMediaDialog.bind(this);
        this.onYearmonthChange = this.onYearmonthChange.bind(this);
        this.onFailStatusChange = this.onFailStatusChange.bind(this);
        this.onSendDonateStatusChange = this.onSendDonateStatusChange.bind(this);
        this.onTypeTurnkeyupcasttimeChange = this.onTypeTurnkeyupcasttimeChange.bind(this);

        this.changeSearchType = this.changeSearchType.bind(this);
        this.renderSearchOption = this.renderSearchOption.bind(this);
    }

    // ------------------------------
    // componentDidMount
    // ------------------------------
    componentDidMount() {

        this.init(this.props);
        this.getInvoiceItemYearmonthList();
    }

    // ------------------------------
    // componentWillReceiveProps
    // ------------------------------
    componentWillReceiveProps(nextProps) {

        this.init(nextProps);
    }

    // ------------------------------
    // init
    // ------------------------------
    init(props) {

        if (!props.match) {
            return;
        }

        const page = props.match.params.page;
        const location = props.location;
        var startDay = this.state.startDay;
        var endDay = this.state.endDay;
        var isFilterTime = false;
        var keyword = this.state.keyword;
        var currentKeyword = this.state.currentKeyword;
        const old_yearmonth = this.state.yearmonth;
        var yearmonth = undefined;
        var isFilterYearmonth = false;
        var old_searchType = this.state.searchType;
        var searchType = undefined;
        var isChange = false;
        let failstatus = '-1';
        let old_failstatus = this.state.failstatus;
        let isFilterFailstatus = false;
        let senddonatestatus = '-1';
        let old_senddonatestatus = this.state.senddonatestatus;
        let isFileterSenddonatestatus = false;
        let typeTurnkeyupcasttime = '0';
        let old_typeTurnkeyupcasttime = this.state.typeTurnkeyupcasttime;
        let isFilterTypeTurnkeyupcasttime = false;        

        if(location && location.search) {
            const querys = parse(location.search.substr(1));

            var starttime = parseInt(querys.starttime, 10);
            var endtime = parseInt(querys.endtime, 10);
            var old_starttime = startDay ? new Date(startDay).getTime() : undefined;
            var old_endtime = endDay ? new Date(endDay).getTime() : undefined;

            if(starttime !== old_starttime) {
                startDay = starttime > 0 ? new Date(starttime) : undefined;
                isChange = true;
            }

            if(endtime !== old_endtime) {
                endDay = endtime > 0 ? new Date(endtime) : undefined;
                isChange = true;
            }

            isFilterTime = starttime || endtime;

            var new_keyword = querys.keyword ? querys.keyword.trim() : '';

            if(new_keyword !== currentKeyword) {
                currentKeyword = new_keyword;
                keyword = keyword ? keyword : currentKeyword;
                isChange = true;
            }

            yearmonth = querys.yearmonth || yearmonth;

            if(yearmonth !== old_yearmonth) {
                isChange = true;
            }
            
            isFilterYearmonth = !!yearmonth;

            searchType = querys.searchType || searchType;

            if(searchType && (searchType !== SearchTypeMap.ORDERID && searchType !== SearchTypeMap.INVOICENUMBER)) {
                searchType = SearchTypeMap.ORDERID;
            }

            if(searchType !== old_searchType) {
                isChange = true;
            }

            failstatus = querys.failstatus || failstatus;

            if(failstatus !== old_failstatus) {
                isChange = true;
            }

            isFilterFailstatus = failstatus > -1;

            senddonatestatus = querys.senddonatestatus || senddonatestatus;

            if(senddonatestatus !== old_senddonatestatus) {
                isChange = true;
            }

            isFileterSenddonatestatus = senddonatestatus > -1;

            typeTurnkeyupcasttime = querys.typeTurnkeyupcasttime || typeTurnkeyupcasttime;

            if(typeTurnkeyupcasttime !== old_typeTurnkeyupcasttime) {
                isChange = true;
            }

            isFilterTypeTurnkeyupcasttime = Number(typeTurnkeyupcasttime) !== 0;
        }

        isChange = isChange || this.state.page !== page;

        if (!isChange) {
            return;
        }

        this.setState({
            page: page,
            isFilterTime: isFilterTime,
            startDay: startDay,
            endDay: endDay,
            keyword: keyword,
            currentKeyword: currentKeyword,
            yearmonth: yearmonth,
            isFilterYearmonth: isFilterYearmonth,
            searchType: searchType,
            failstatus,
            isFilterFailstatus,
            senddonatestatus,
            isFileterSenddonatestatus,
            typeTurnkeyupcasttime,
            isFilterTypeTurnkeyupcasttime,
        });
    }

    // ------------------------------
    // 取得開立發票存在的期別列表 
    // ------------------------------
    getInvoiceItemYearmonthList() {

        if(!Array.isArray(this.props.yearmonthList) || this.props.yearmonthList.length === 0) {
            this.props.invoiceActions.getInvoiceItemYearmonthList();
        }
    }

    // ------------------------------
    // 下載發票
    // ------------------------------
    dnldInvoice(invoice){

        const x = new XMLHttpRequest();
        x.open( "GET", '/InvoiceAction.do?op=dnldInvoice&yearmonth='+
            invoice.yearmonth+'&istarttag='+invoice.istarttag+'&invoiceNumber='+
            invoice.invoicenumber + '&invoiceType='+invoice.invoicetype , true);
        x.responseType="blob";
        x.onload = function(e){download(e.target.response, 
            invoice.istarttag+'-'+invoice.invoicenumber+'.xls', 
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet");
        };
        x.send();
    }

    // ------------------------------
    // 作廢發票
    // ------------------------------
    failInvoice(item) {
        
        this.props.webActions.openConfirmDialog({
            title: '確定作廢發票'+item.istarttag+item.invoicenumber+'？',
            confirmCallback: () => {
                this.props.invoiceActions.failInvoice(item)
            },
        });
    }


    // ------------------------------
    // 設為已寄送
    // ------------------------------
    setInvoiceSent(item) {
        
        this.props.webActions.openConfirmDialog({
            title: '確定將發票'+item.istarttag+item.invoicenumber+'設為已寄送？',
            confirmCallback: () => {
                this.props.invoiceActions.updateInvoiceStatus({
                    yearmonth: item.yearmonth,
                    istarttag: item.istarttag,
                    invoiceNumber: item.invoicenumber,
                    istatus: 4,
                })
            },
        });
    }

    // ------------------------------
    // 切換過濾時間
    // ------------------------------
    toggleIsFilterTime(isFilterTime) {

        this.setState({
            isFilterTime: isFilterTime,
        }, () => {
            this.onFilterChange();
        })
    }

    // ------------------------------
    // 時間變動
    // ------------------------------
    onDaySelectChange(selectedDay, modifiers, statekey) {

        const dayValue = formatDate(selectedDay, 'YYYY/MM/DD');
        const value = new Date(dayValue);

        this.setState({
            [statekey]: value,
            isFilterTime: true,
        }, () => {
            this.onFilterChange();
        });
    }

    // ------------------------------
    // 任何過濾條件變動
    // ------------------------------
    onFilterChange() {

        const {
            startDay,
            endDay,
            isFilterTime,
            currentKeyword,
            yearmonth,
            isFilterYearmonth,
            searchType,
            failstatus,
            isFilterFailstatus,
            senddonatestatus,
            isFilterSenddonatestatus,
            typeTurnkeyupcasttime,
            isFilterTypeTurnkeyupcasttime,
        } = this.state;

        var querys = {};

        if(isFilterTime) {

            var new_startDay = new Date(startDay);
            var new_endDay = new Date(endDay);


            if(!isNaN(new_startDay)) {
                querys.starttime = new_startDay.getTime();
            }

            if(!isNaN(new_endDay)) {
                querys.endtime = new_endDay.getTime();
            }
        }

        if(currentKeyword && currentKeyword.trim()) {
            querys.keyword = currentKeyword;
        }

        if(isFilterYearmonth) {
            querys.yearmonth = yearmonth;
        }
        if(isFilterFailstatus) {
            querys.failstatus = failstatus;
        }
        if(isFilterSenddonatestatus) {
            querys.senddonatestatus = senddonatestatus;
        }
        if(isFilterTypeTurnkeyupcasttime) {
            querys.typeTurnkeyupcasttime = typeTurnkeyupcasttime;
        }

        if(searchType === SearchTypeMap.ORDERID) {
            // Nothing to do
        } else if(searchType === SearchTypeMap.INVOICENUMBER) {
            querys.searchType = searchType;
        }

        const statename = CupoyRouter.STATES.INVOICE_LIST;
        const params = {
            page: 1,
        };

        this.props.webActions.cupoyStateGo(statename, params, querys);
    }

    // ------------------------------
    // 搜尋input變動
    // ------------------------------
    onInputChange(event) {

        event.preventDefault();

        const keyword = event.target.value;

        this.setState({
            keyword: keyword,
        });

        if(!keyword) {
            this.deb_searchSubmit('');
        } else {
            this.deb_searchSubmit(keyword);
        }
    }
    
    // ------------------------------
    // 搜尋按下enter
    // ------------------------------
    enterSubmit(event) {

        if(event && event.key === 'Enter') {
            event.preventDefault();
            this.searchSubmit(this.state.keyword);
        }
    }

    // ------------------------------
    // 搜尋
    // ------------------------------
    searchSubmit(keyword) {
        
        this.setState({
            currentKeyword: keyword,
        }, () => {
            this.onFilterChange();
        });
    }

    // ------------------------------
    // 開啟下載發票媒體申報檔 modal
    // ------------------------------
    openDownloadTaxMediaDialog(event) {

        this.props.invoiceActions.openDownloadTaxMediaDialog();
    }

    // ------------------------------
    // 期別更動
    // ------------------------------
    onYearmonthChange(event) {

        var yearmonth = event.target.value;

        this.setState({
            yearmonth: yearmonth,
            isFilterYearmonth: !!yearmonth,
        }, () => {
            this.onFilterChange();
        })
    }

    onFailStatusChange(failstatus) {

        this.setState({
            failstatus: failstatus,
            isFilterFailstatus: Number(failstatus) > -1,
        }, () => {
            this.onFilterChange();
        })
    }

    onSendDonateStatusChange(senddonatestatus) {

        this.setState({
            senddonatestatus: senddonatestatus,
            isFilterSenddonatestatus: Number(senddonatestatus) > -1,
        }, () => {
            this.onFilterChange();
        })
    }

    onTypeTurnkeyupcasttimeChange(typeTurnkeyupcasttime) {

        this.setState({
            typeTurnkeyupcasttime: typeTurnkeyupcasttime,
            isFilterTypeTurnkeyupcasttime: Number(typeTurnkeyupcasttime) !== 0,
        }, () => {
            this.onFilterChange();
        })
    }

    // ------------------------------
    // 切換搜尋類型
    // ------------------------------
    changeSearchType(searchType) {

        if(searchType === this.state.searchType) {
            return;
        }

        this.setState({
            searchType: searchType,
        }, () => {
            if(this.state.keyword) {
                this.onFilterChange();
            }
        })
    }

    // ------------------------------
    // 將 DatePicker style改為absolute
    // ------------------------------
    renderCustomDayPickerOverlay({ classNames, selectedDay, children }) {

        return (
            <div className={classNames.overlayWrapper} style={{ position: 'absolute', lineHeight: 'normal' }}>
                <div className={classNames.overlay}>
                    {children}
                </div>
            </div>
        );
    }

    // ------------------------------
    // render filter區塊
    // ------------------------------
    renderFilterContent(querys) {

        const {
            isFilterTime,
            startDay,
            endDay,
            yearmonth,
            failstatus,
            senddonatestatus,
            typeTurnkeyupcasttime,
        } = this.state;

        const {
            yearmonthList,
        } = this.props;

        const startDayValue = startDay ? formatDate(startDay, 'YYYY/MM/DD') : '';
        const endDayValue = endDay ? formatDate(endDay, 'YYYY/MM/DD') : '';

        return (
            <div className="form">
                <table className="form-table">
                    <tbody>
                        <tr className="form-row">
                            <td className="form-col label-text">開立時間</td>
                            <td className="form-col">
                                <div 
                                    className={classNames("button button-outline", {
                                       'selected': !isFilterTime
                                    })}
                                    onClick={() => this.toggleIsFilterTime(false)}
                                >
                                    不限
                                </div>
                                <div 
                                    className={classNames("button button-outline", {
                                       'selected': isFilterTime
                                    })}
                                    onClick={() => this.toggleIsFilterTime(true)}
                                >
                                    指定區間
                                </div>
                                <DayPickerInput
                                    overlayComponent={this.renderCustomDayPickerOverlay}
                                    onDayChange={(selectedDay, modifiers) => this.onDaySelectChange(selectedDay, modifiers, 'startDay')}
                                    formatDate={formatDate}
                                    parseDate={parseDate}
                                    format="YYYY/MM/DD"
                                    value={startDayValue}
                                    dayPickerProps={{
                                        selectedDays: startDay,
                                    }}
                                    placeholder="起"
                                />
                                <span className="line"></span>
                                <DayPickerInput
                                    overlayComponent={this.renderCustomDayPickerOverlay}
                                    onDayChange={(selectedDay, modifiers) => this.onDaySelectChange(selectedDay, modifiers, 'endDay')}
                                    formatDate={formatDate}
                                    parseDate={parseDate}
                                    format="YYYY/MM/DD"
                                    value={endDayValue}
                                    dayPickerProps={{
                                        selectedDays: endDay,
                                    }}
                                    placeholder="訖"
                                />
                            </td>
                        </tr>
                        {yearmonthList.length > 0 ?
                            <tr className="form-row">
                                <td className="form-col label-text">發票期別</td>
                                <td className="form-col">
                                    <div className="form-select fileter-large-content">
                                        <select value={yearmonth} onChange={(event) => this.onYearmonthChange(event)}>
                                            <option value={''} key={''}>---</option>
                                            {yearmonthList.map((_yearmonth, index)=> {
                                                return (<option value={_yearmonth} key={_yearmonth}>{_yearmonth}</option>)
                                            })}
                                        </select>
                                        <div className="select-arrow"><i className="zmdi zmdi-caret-down"></i></div>
                                    </div>
                                </td>
                            </tr>
                            :
                            null
                        }
                        <tr className="form-row">
                            <td className="form-col label-text">發票作廢狀態</td>
                            <td className="form-col">
                                <div
                                    className={classNames("button button-outline", {
                                       'selected': Number(failstatus) === -1 || failstatus === undefined
                                    })}
                                    onClick={(event) => this.onFailStatusChange('-1')}
                                >
                                    不限
                                </div>
                                <div
                                    className={classNames("button button-outline", {
                                       'selected': Number(failstatus) === 0
                                    })}
                                    onClick={(event) => this.onFailStatusChange('0')}
                                >
                                    未作廢
                                </div>
                                <div
                                    className={classNames("button button-outline", {
                                       'selected': Number(failstatus) === 1
                                    })}
                                    onClick={(event) => this.onFailStatusChange('1')}
                                >
                                    已作廢
                                </div>
                            </td>
                        </tr>
                        <tr className="form-row">
                            <td className="form-col label-text">發票寄送捐贈狀態</td>
                            <td className="form-col">
                                <div
                                    className={classNames("button button-outline", {
                                       'selected': Number(senddonatestatus) === -1 || senddonatestatus === undefined
                                    })}
                                    onClick={(event) => this.onSendDonateStatusChange('-1')}
                                >
                                    不限
                                </div>
                                <div
                                    className={classNames("button button-outline", {
                                       'selected': Number(senddonatestatus) === 1
                                    })}
                                    onClick={(event) => this.onSendDonateStatusChange('1')}
                                >
                                    捐贈
                                </div>
                                <div
                                    className={classNames("button button-outline", {
                                       'selected': Number(senddonatestatus) === 2
                                    })}
                                    onClick={(event) => this.onSendDonateStatusChange('2')}
                                >
                                    未寄出
                                </div>
                                <div
                                    className={classNames("button button-outline", {
                                       'selected': Number(senddonatestatus) === 3
                                    })}
                                    onClick={(event) => this.onSendDonateStatusChange('3')}
                                >
                                    中獎未寄出
                                </div>
                                <div
                                    className={classNames("button button-outline", {
                                       'selected': Number(senddonatestatus) === 4
                                    })}
                                    onClick={(event) => this.onSendDonateStatusChange('4')}
                                >
                                    已寄出
                                </div>
                            </td>
                        </tr>
                        <tr className="form-row">
                            <td className="form-col label-text">發票上傳狀態</td>
                            <td className="form-col">
                                <div
                                    className={classNames("button button-outline", {
                                       'selected': Number(typeTurnkeyupcasttime) === 0 || typeTurnkeyupcasttime === undefined
                                    })}
                                    onClick={(event) => this.onTypeTurnkeyupcasttimeChange('0')}
                                >
                                    不限
                                </div>
                                <div
                                    className={classNames("button button-outline", {
                                       'selected': Number(typeTurnkeyupcasttime) === 1
                                    })}
                                    onClick={(event) => this.onTypeTurnkeyupcasttimeChange('1')}
                                >
                                    已上傳
                                </div>
                                <div
                                    className={classNames("button button-outline", {
                                       'selected': Number(typeTurnkeyupcasttime) === -1
                                    })}
                                    onClick={(event) => this.onTypeTurnkeyupcasttimeChange('-1')}
                                >
                                    未上傳
                                </div>
                                <div
                                    className={classNames("button button-outline", {
                                       'selected': Number(typeTurnkeyupcasttime) === -2
                                    })}
                                    onClick={(event) => this.onTypeTurnkeyupcasttimeChange('-2')}
                                >
                                    上傳失敗
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        )
    }

    // ------------------------------
    // render search 選項
    // ------------------------------
    renderSearchOption() {

        return (
            <ul>
                <li onClick={(event) => this.changeSearchType(SearchTypeMap.ORDERID)}><a>訂單編號</a></li>
                <li onClick={(event) => this.changeSearchType(SearchTypeMap.INVOICENUMBER)}><a>發票號碼</a></li>
            </ul>
        )
    }

    // ------------------------------
    // render
    // ------------------------------
    render() {

        const { page, keyword, searchType } = this.state;
        const { pageLen, totalCount, location } = this.props;
        const num_page = Number(page);
        var querys = {};

        if(location && location.search) {
            querys = parse(location.search.substr(1));
        }

        var searchTypeString = '訂單編號';

        if(searchType === SearchTypeMap.ORDERID) {
            searchTypeString = '訂單編號';
        } else if(searchType === SearchTypeMap.INVOICENUMBER) {
            searchTypeString = '發票號碼';
        }
        
        return (
            <div id="invoice">
                <div className="header-bar mix">
                    <h1 className="title">開立發票列表</h1>
                    <div className="search-bar has-option">
                        <Dropdown
                            defaultVisible={false}
                            overlay={this.renderSearchOption()}
                            trigger={['click']}
                            placement="bottomCenter"
                            overlayClassName="dropdown selected-option-dropdown popup open"
                            overlayStyle={{ position: 'absolute' }}
                            zIndex={2000}
                        >
                            <div className="selected-option">
                                {searchTypeString}
                                <div className="arrow-icon"><AngleDownIcon/></div>
                            </div>
                        </Dropdown>
                        <input 
                            type="search"
                            placeholder={"搜尋" + searchTypeString}
                            value={keyword}
                            onChange={(event) => this.onInputChange(event)}
                            onKeyPress={(event) => this.enterSubmit(event)}
                        />
                        <div className="search-icon pointer"><SearchIcon/></div>
                    </div>

                    <div className="button-group">
                        <div className="button blue" onClick={() => this.openDownloadTaxMediaDialog()}>
                            下載發票報表、媒體申報檔
                        </div>
                    </div>
                </div>
                <PagedList
                    page={num_page}
                    pageLen={pageLen}
                    totalCount={totalCount}
                    colspan={12}
                    querys={querys}
                    getListItemFrom={(start, querys) => {

                        var orderid = undefined, invoiceNumber = undefined;

                        switch(searchType) {
                            case SearchTypeMap.ORDERID:
                                orderid = querys.keyword;
                                break;
                            case SearchTypeMap.INVOICENUMBER:
                                invoiceNumber = querys.keyword;
                                // 去掉字軌
                                if(invoiceNumber) {
                                    if(invoiceNumber.length === 11) {
                                        invoiceNumber = invoiceNumber.substr(3);
                                    } else if(invoiceNumber.length === 10) {
                                        invoiceNumber = invoiceNumber.substr(2);
                                    }
                                }

                                break;
                            default:
                                orderid = querys.keyword;
                                break;
                        }

                        return this.props.invoiceActions.getInvoiceList({ 
                            start: start,
                            starttime: querys.starttime,
                            endtime: querys.endtime,
                            orderid: orderid,
                            yearmonth: querys.yearmonth,
                            invoiceNumber: invoiceNumber,
                            failstatus: querys.failstatus,
                            senddonatestatus: querys.senddonatestatus,
                            typeTurnkeyupcasttime: querys.typeTurnkeyupcasttime,
                        });
                    }}
                    pageStateName={CupoyRouter.STATES.INVOICE_LIST}
                    getItemsInRanage={(start, end) => {
                        return filter(this.props.invoiceList, (item, index) => {
                            return Number(index) >= start && Number(index) < (end);
                        });
                    }}
                    renderItemHeaderRow={(item, index) => {
                        return <InvoiceListHeader/>;
                    }}
                    renderItemRow={(item, index, start) => {
                        return <InvoiceListItem
                            key={item}
                            item={this.props.invoices[item]}
                            start={start}
                            index={index}
                            dnldInvoice={this.dnldInvoice}
                            failInvoice={(item)=>this.failInvoice(item)}
                            
                            setInvoiceSent={(item) =>this.setInvoiceSent(item)}
                        />;
                    }}
                    renderFilterContent={() => {
                        return this.renderFilterContent(querys);
                    }}
                />
            </div>
        );
    }
}

/*--------------------------
    Reducer Props
--------------------------*/
const mapStateToProps = function (state) {
    return {
        invoiceList: state.invoice.invoiceList,
        invoices: state.invoice.invoices,
        pageLen: state.invoice.pageLen,
        totalCount: state.invoice.totalCount,
        yearmonthList: state.invoice.yearmonthList,
    };
};

/*--------------------------
    Reducer Action
--------------------------*/
const mapActionToProps = function (dispatch) {
    return {
        invoiceActions: bindActionCreators(actionCreators.invoiceActionCreators, dispatch),
        webActions: bindActionCreators(actionCreators.webActionCreators, dispatch), 
    };
};

/*--------------------------
    export
--------------------------*/
export default connect(mapStateToProps, mapActionToProps, null, {
    withRef: true
})(InvoiceListView);


// WEBPACK FOOTER //
// ./src/components/invoice/InvoiceListView.jsx